import { useEffect, useState } from "react";
import { api, mesajEroare } from "./api.js";
import { tr } from "./i18n.js";
import { ROLURI as ETICHETE } from "./enums.js";

const ROLURI_PRESTATOR = [
  "ADMIN_TENANT", "MANAGER_TEHNIC", "DISPECER", "COORDONATOR",
  "TEHNICIAN", "MAGAZIONER", "FINANCIAR", "AUDITOR",
];
const ROLURI_CLIENT = ["CLIENT_ADMIN", "CLIENT_UTILIZATOR", "CLIENT_FINANCIAR"];
const TOATE_ROLURILE = [...ROLURI_PRESTATOR, ...ROLURI_CLIENT];

const GOL = { email: "", parola: "", numeComplet: "", rol: "TEHNICIAN" };

export default function Utilizatori({ eu }) {
  const [lista, setLista] = useState([]);
  const [incarca, setIncarca] = useState(true);
  const [eroare, setEroare] = useState("");
  const [formular, setFormular] = useState(GOL);
  const [seSalveaza, setSeSalveaza] = useState(false);

  // Cine poate crea conturi se citește din MATRICE, nu dintr-o listă de roluri
  // scrisă aici. Implicit e tot administratorul — dar când firma bifează
  // „administrare" pe modulul Utilizatori pentru managerul tehnic, butonul
  // apare, fără nicio modificare de cod. Altfel bifa ar schimba doar ce acceptă
  // serverul, nu și ce se vede pe ecran.
  const [poateAdministra, setPoateAdministra] = useState(eu.rol === "ADMIN_TENANT");

  async function reincarca() {
    setIncarca(true);
    try {
      setLista(await api.utilizatori());
      setEroare("");
    } catch (e) {
      setEroare(mesajEroare(e));
    } finally {
      setIncarca(false);
    }
  }

  useEffect(() => {
    // Dacă cererea pică, rămâne valoarea de pornire (doar administratorul) —
    // un ecran care nu știe ce drepturi ai arată mai puțin, nu mai mult.
    api.drepturileMele()
      .then((d) => setPoateAdministra((d?.utilizatori ?? []).includes("administrare")))
      .catch(() => {});
  }, []);

  useEffect(() => { reincarca(); }, []);

  async function creeaza(e) {
    e.preventDefault();
    setSeSalveaza(true);
    setEroare("");
    try {
      await api.creeazaUtilizator({
        email: formular.email.trim(),
        parola: formular.parola,
        numeComplet: formular.numeComplet.trim(),
        rol: formular.rol,
      });
      setFormular(GOL);
      await reincarca();
    } catch (err) {
      setEroare(mesajEroare(err));
    } finally {
      setSeSalveaza(false);
    }
  }

  async function dezactiveaza(u) {
    setEroare("");
    try {
      await api.dezactiveazaUtilizator(u.id);
      await reincarca();
    } catch (err) {
      setEroare(mesajEroare(err));
    }
  }

  const esteRolClient = ROLURI_CLIENT.includes(formular.rol);

  return (
    <div className="continut">
      <h2>{tr("Utilizatori")}</h2>
      <p className="subtitlu">
        {tr("Conturile firmei și ale clienților deserviți. Un cont nu se șterge niciodată — se dezactivează, ca istoricul lui să rămână verificabil.")}
      </p>

      {eroare && <div className="eroare" role="alert">{eroare}</div>}

      {poateAdministra && (
        <div className="panou">
          <div className="panou-antet">{tr("Cont nou")}</div>
          <div className="panou-corp">
            <form onSubmit={creeaza}>
              <div className="formular-linie">
                <div className="camp">
                  <label htmlFor="nume">{tr("Nume complet")}</label>
                  <input id="nume" required minLength={3} value={formular.numeComplet}
                    onChange={(e) => setFormular({ ...formular, numeComplet: e.target.value })} />
                </div>
                <div className="camp">
                  <label htmlFor="mail">{tr("Email")}</label>
                  <input id="mail" type="email" required value={formular.email}
                    onChange={(e) => setFormular({ ...formular, email: e.target.value })} />
                </div>
                <div className="camp">
                  <label htmlFor="rol">{tr("Rol")}</label>
                  <select id="rol" value={formular.rol}
                    onChange={(e) => setFormular({ ...formular, rol: e.target.value })}>
                    <optgroup label="Firma prestatoare">
                      {ROLURI_PRESTATOR.map((r) => <option key={r} value={r}>{tr(ETICHETE[r])}</option>)}
                    </optgroup>
                    <optgroup label="Client deservit">
                      {ROLURI_CLIENT.map((r) => <option key={r} value={r}>{tr(ETICHETE[r])}</option>)}
                    </optgroup>
                  </select>
                </div>
                <div className="camp">
                  <label htmlFor="parola-noua">{tr("Parolă inițială")}</label>
                  <input id="parola-noua" type="password" required minLength={12}
                    value={formular.parola}
                    onChange={(e) => setFormular({ ...formular, parola: e.target.value })} />
                </div>
              </div>

              {esteRolClient && (
                <div className="eroare" style={{ background: "#fff8e6", borderColor: "var(--atentie)", color: "#7a5c0a" }}>
                  {tr("Un cont de client trebuie legat de o companie. Companiile se administrează în MT04, care vine în faza următoare — până atunci, creează doar conturi ale firmei.")}
                </div>
              )}

              <button className="buton buton-mic" type="submit"
                disabled={seSalveaza || esteRolClient}>
                {seSalveaza ? tr("Se creează…") : tr("Creează contul")}
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="panou">
        <div className="panou-antet">
          {tr("Conturi existente")}
          <span className="eticheta">{lista.length}</span>
        </div>
        {incarca ? (
          <div className="gol">{tr("Se încarcă…")}</div>
        ) : lista.length === 0 ? (
          <div className="gol">{tr("Niciun cont.")}</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>{tr("Nume")}</th><th>{tr("Email")}</th><th>{tr("Rol")}</th><th>{tr("Stare")}</th>
                <th>{tr("Ultima autentificare")}</th>{poateAdministra && <th></th>}
              </tr>
            </thead>
            <tbody>
              {lista.map((u) => (
                <tr key={u.id}>
                  <td>{u.numeComplet}{u.id === eu.id && <span className="eticheta" style={{ marginLeft: ".5rem" }}>{tr("tu")}</span>}</td>
                  <td>{u.email}</td>
                  <td>
                    <span className={"eticheta" + (ROLURI_CLIENT.includes(u.rol) ? " eticheta-client" : "")}>
                      {tr(ETICHETE[u.rol] || u.rol)}
                    </span>
                  </td>
                  <td>
                    <span className={"eticheta " + (u.activ ? "eticheta-activ" : "eticheta-inactiv")}>
                      {u.activ ? tr("Activ") : tr("Dezactivat")}
                    </span>
                  </td>
                  <td>
                    {u.ultimaAutentificare
                      ? new Date(u.ultimaAutentificare).toLocaleString("ro-RO")
                      : <span style={{ color: "var(--text-sters)" }}>{tr("niciodată")}</span>}
                  </td>
                  {poateAdministra && (
                    <td style={{ textAlign: "right" }}>
                      {u.activ && u.id !== eu.id && (
                        <button className="buton buton-mic buton-sters" onClick={() => dezactiveaza(u)}>
                          {tr("dezactivează")}
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export { TOATE_ROLURILE, ETICHETE };
